import styled from "styled-components"

export const TableColumn = styled.td `
  text-transform: capitalize;
`
export const StatusText = styled.span`
  font-weight: bold;
`
